<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <router-link to="/dashboard">
          <mini-statistics-card
            title="Static"
            value="Dashboard"
            :percentage="{
              value: '+505%',
              color: 'text-success',
            }"
            :icon="{
              component: 'ni ni-money-coins',
              background: iconBackground,
            }"
            direction-reverse
          />
        </router-link>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <router-link to="/swith_client">
          <mini-statistics-card
            title="Select"
            value="Client"
            :percentage="{
              value: '+505%',
              color: 'text-success',
            }"
            :icon="{
              component: 'ni ni-basket',
              background: iconBackground,
            }"
            direction-reverse
          />
        </router-link>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <router-link to="/timesheet">
          <mini-statistics-card
            title="Total"
            value="Timesheets"
            :percentage="{
              value: '+3%',
              color: 'text-success',
            }"
            :icon="{
              component: 'ni ni-world',
              background: iconBackground,
            }"
            direction-reverse
          />
        </router-link>
      </div>

      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <router-link to="/Message">
          <mini-statistics-card
            title="Messages"
            value="Message Center"
            :percentage="{
              value: '-2%',
              color: 'text-danger',
            }"
            :icon="{
              component: 'ni ni-paper-diploma',
              background: iconBackground,
            }"
            direction-reverse
          />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";

import {
  faHandPointer,
  faUsers,
  faCreditCard,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
export default {
  name: "dashboard-default",
  data() {
    return {
      iconBackground: "bg-gradient-success",
      faCreditCard,
      faScrewdriverWrench,
      faUsers,
      faHandPointer,
    };
  },
  components: {
    MiniStatisticsCard,
  },
};
</script>
